import { render, staticRenderFns } from "./GerenciarStatus.vue?vue&type=template&id=335976a2&"
import script from "./GerenciarStatus.vue?vue&type=script&lang=js&"
export * from "./GerenciarStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports